import * as mapboxgl from 'mapbox-gl';
import { GeoJSONSource } from 'mapbox-gl';
import Mapbox from 'index.vue';
import { BaseFeatureLayer } from './baseFeatureLayer';
export class AreaLayer
{
    protected mapboxInstance: InstanceType<typeof Mapbox>;
    protected fillLayer: BaseFeatureLayer;
    protected outlinesLayer: BaseFeatureLayer;


    constructor(mapboxInstance: InstanceType<typeof Mapbox>) {
        this.mapboxInstance = mapboxInstance;
        this.fillLayer = new BaseFeatureLayer(mapboxInstance, 'top', 'area-fill-layer', 'area-fill-source', 'fill', {}, {
            'fill-color': '#4CAF40',
            'fill-opacity': 0.6
        }, true);
        this.outlinesLayer = new BaseFeatureLayer(mapboxInstance, 'top', 'area-outlines-layer', 'area-outlines-source', 'line', {}, {
            'line-color': '#24714D',
            'line-width': 3
        });
    }
    
    public DataChanged = async (leftPadding: number = 0, rightPadding: number = 0) => {
        this.fillLayer.SetFeatures(this.mapboxInstance.area == null ? [] : this.mapboxInstance.area.featureCollection);
        this.outlinesLayer.SetFeatures(this.mapboxInstance.area == null ? [] : this.mapboxInstance.area.featureCollection);
        if (this.mapboxInstance.area != null) {
            const fitOptions = {
                padding: { top: 30, right: rightPadding + 60, left: leftPadding + 60, bottom: 30 },
                maxZoom: 12,
                duration: 1000, // Smooth animation duration in milliseconds
            };
            const bounds = new mapboxgl.LngLatBounds();
            this.mapboxInstance.area.featureCollection.forEach((feature: any) => feature.geometry.coordinates.forEach((coord: any) => bounds.extend(coord)));
            this.mapboxInstance.map.fitBounds(bounds, fitOptions);
        }
    };
}   
